<notification></notification>
<main class="main-process">
  <div class="container">
    <app-status-bar></app-status-bar>
    <div class="row">
      <aside class="col-xl-4 col-lg-4 col-12">
        <div class="row d-flex">
          <section class="col-xl-12 col-lg-12 col-12">
            <app-ask-state></app-ask-state>
            <div
              appHiddenElement
              idE="mensajes-muro"
              id="wall-widget-container"
              url="/dashboard/tus-mensajes"
              isDifferent="true"
            >
              <div class="wall-title-container">
                <h3 class="h-main h-main-medium corporate" (click)="collapseWall = !collapseWall">
                  {{ 'wall_widget_title' | translate }}
                  <a
                    href="javascript:;"
                    class="colapse-arrow"
                    [ngClass]="{ 'ic-arrow-short-down': collapseWall, 'ic-arrow-short-up': !collapseWall }"
                  ></a>
                </h3>

                <a class="new-msg-link" routerLink="tus-mensajes">
                  {{ 'Enviar nuevo' | translate }}
                </a>
              </div>

              <div class="wall-widget" [ngClass]="{ 'colapse-box colapsed': collapseWall }">
                <div class="msg-notification row">
                  <div class="col-12 no-pd">
                    <a id="wall-widget-msg-unread" class="unread-msg-link" routerLink="tus-mensajes">
                      <span class="new-msg-number ic ic-envelope">{{ unread }}</span>
                      {{ 'wall_widget_msg_unread' | translate }}
                    </a>
                  </div>
                </div>
                <app-wall-container [markAsRead]="false"></app-wall-container>
                <!-- <div class="more-btn-container d-flex justify-content-end">
                                    <a id="wall-widget-btn-show-more" class="btn btn-01 more-btn" routerLink="tus-mensajes">{{ 'wall_widget_btn_show_more' | translate }}</a>
                                </div> -->
                <div class="wall-overlay"></div>
              </div>
            </div>
          </section>
          <section class="col-xl-12 col-lg-12 col-12" idE="bola" appHiddenElement isDifferent="true">
            <app-your-mortgage [isRejected]="isRejected" [status]="status"></app-your-mortgage>
          </section>
        </div>
      </aside>
      <!-- <section class="col-xl-8 col-lg-8 col-12"> -->
      <!-- a este nivel, si el estado es RECHAZADO, se le añade la class  rejected-container-->
      <section class="col-xl-8 col-lg-8 col-12 rejected-container">
        @if (isRejected) {
          <article>
            <!-- <section class="rejected-container" *ngIf="isRejected"> -->
            <div class="col-12 no-pd">
              <app-rejected-mortgage [listRejectReasons]="listRejectReasons"></app-rejected-mortgage>
            </div>
          </article>
        }
        <article class="dashboard-section">
          <div class="col-12 no-pd">
            <!-- tabla datos hipoteca -->
            <app-your-mortgage
              formatTable="true"
              [class.disabled]="isRejected"
              [status]="status"
              idE="tabla"
              appHiddenElement
              hiddenInError="true"
            ></app-your-mortgage>
          </div>
          <router-outlet></router-outlet>
        </article>
      </section>
    </div>
  </div>
</main>
<app-modal></app-modal>
